<div class="main-content-container">
  <div class="main-container-body">
    @if (!id) {
    <div class="page-title-container d-flex">
      @if (!utilService.isMobile()) {
      <div class="page-title flex-grow-1 ng-star-inserted">
        <div class="mb-0 ng-star-inserted">
          <div class="d-flex align-items-center">
            @if (showbackButton) {
            <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex" (click)="previous()"
                href="javascript:void(0)"><img src="assets/images/grid-back.png"></a>
            </div>
            }
            <div class="text-capitalize"> {{'field.label.patient_queue' | translate | async}} </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (!id) {
    <div class="app-ui-engine-container main-box-shadow pvq-wrapper">
      @for (q of queue; track q) {
      <div class="pvq-card">
        @if (q.queue_desk_id == undefined) {
        <div class="pvq-header-row">
          <div class="pvq-header-doctor">
            <div class="pvq-avatar text-uppercase">{{getDoctorInitials(q.doctor_name)}}
            </div>
            <div class="pvq-doctor-text">
              <div class="pvq-name text-capitalize">
                {{q.doctor_name}}
                <i class="fa fa-check-circle pvq-verified-badge" aria-hidden="true"></i>
              </div>
              <div class="pvq-sub text-capitalize">{{q.speciality_name}}</div>
            </div>
          </div>
          <div class="pvq-header-divider"></div>
          <div class="pvq-header-info">
            <span class="pvq-header-info-icon pvq-header-info-icon-blue"><i class="fa fa-id-card-o"
                aria-hidden="true"></i></span>
            <div>
              <span class="pvq-header-info-label">{{'field.label.appointmentId' | translate | async}}</span>
              <span class="pvq-header-info-value">{{q.appointmentId}}</span>
            </div>
          </div>
          @if(q.room_name){
          <div class="pvq-header-divider"></div>
          <div class="pvq-header-info">
            <span class="pvq-header-info-icon pvq-header-info-icon-purple"><i class="fa fa-hospital-o"
                aria-hidden="true"></i></span>
            <div>
              <span class="pvq-header-info-label">{{'field.label.room_no' | translate | async}}</span>
              <span class="pvq-header-info-value">{{q.room_name}}</span>
            </div>
          </div>
          }
        </div>

        <div class="pvq-kpi-row">
          @if (q.token_number != undefined) {
          <div class="pvq-kpi pvq-kpi-blue">
            <span class="pvq-kpi-label">{{'field.label.your_token_number' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{q.token_number}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-ticket" aria-hidden="true"></i></span>
            </div>
            <div class="pvq-kpi-bar"></div>
          </div>
          }
          @if (q.current_serving_token != undefined) {
          <div class="pvq-kpi pvq-kpi-green">
            <span class="pvq-kpi-label">{{'field.label.currently_serving' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{q.current_serving_token}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-user" aria-hidden="true"></i></span>
            </div>

            <div class="pvq-kpi-bar"></div>
          </div>
          }
          @if (q.pending_in_queue != undefined) {
          <div class="pvq-kpi pvq-kpi-orange">
            <span class="pvq-kpi-label">{{'field.label.patients_ahead_in_queue' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{q.pending_in_queue}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-users" aria-hidden="true"></i></span>
            </div>

            <div class="pvq-kpi-bar"></div>
          </div>
          }
          @if (waitingTime) {
          <div class="pvq-kpi pvq-kpi-purple">
            <span class="pvq-kpi-label">{{'field.label.estimated_wait_time' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{calculateWaitingTime(waitingTime)}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
            </div>

            <div class="pvq-kpi-bar"></div>
          </div>
          }
        </div>

        <div class="pvq-notice-banner">
          <span class="pvq-notice-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
          <span>{{'field.label.queue_patience_message' | translate | async}}</span>
        </div>
        }

        @if (q.queue_desk_id != undefined) {
        <div class="pvq-header-row">
          <div class="pvq-header-doctor">
            <div class="pvq-avatar text-uppercase">{{q.department_name.trim().split('
              ')[0][0]}}{{q.department_name.trim().split(' ').slice(-1)[0][0]}}</div>
            <div class="pvq-doctor-text">
              <div class="pvq-name text-capitalize">{{q.department_name}}</div>
              <div class="pvq-sub text-capitalize">{{'field.label.desk_name' | translate | async}} : {{q.desk_name}}</div>
            </div>
          </div>
          <div class="pvq-header-divider"></div>
          <div class="pvq-header-info">
            <span class="pvq-header-info-icon pvq-header-info-icon-blue"><i class="fa fa-id-card-o"
                aria-hidden="true"></i></span>
            <div>
              <span class="pvq-header-info-label">{{'field.label.consumed_by' | translate | async}}</span>
              <span class="pvq-header-info-value text-capitalize">{{q.g_created_by_name}}</span>
            </div>
          </div>
        </div>

        <div class="pvq-kpi-row">
          <div class="pvq-kpi pvq-kpi-blue">
            <span class="pvq-kpi-label">{{'field.label.your_token_number' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{q.token}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-ticket" aria-hidden="true"></i></span>
            </div>

            <div class="pvq-kpi-bar"></div>
          </div>
          @if (q.extra_data?.pending_in_queue != undefined) {
          <div class="pvq-kpi pvq-kpi-orange">
            <span class="pvq-kpi-label">{{'field.label.patients_ahead_in_queue' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{q.extra_data.pending_in_queue}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-users" aria-hidden="true"></i></span>
            </div>
            <div class="pvq-kpi-bar"></div>
          </div>
          }
          @if (waitingTime) {
          <div class="pvq-kpi pvq-kpi-purple">
            <span class="pvq-kpi-label">{{'field.label.estimated_wait_time' | translate | async}}</span>
            <div class="pvq-kpi-main">
              <span class="pvq-kpi-value">{{calculateWaitingTime(waitingTime)}}</span>
              <span class="pvq-kpi-icon"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
            </div>

            <div class="pvq-kpi-bar"></div>
          </div>
          }
        </div>

        <div class="pvq-notice-banner">
          <span class="pvq-notice-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
          <span>{{'field.label.queue_patience_message' | translate | async}}</span>
        </div>
        }
      </div>
      }
      @if (showMessage) {
      <div class="pvq-no-data">
        <i class="fa fa-inbox" aria-hidden="true"></i>
        <span>{{'field.label.no_data_found' | translate | async}}</span>
      </div>
      }
    </div>
    }
    @if (id) {
    <span>
      @for (q of queue; track q) {
      <div class="pvq-inline-summary">
        @if (q.queue_desk_id == undefined) {
        <span>{{'field.label.your_number_is' | translate | async}} {{q.pending_in_queue+1}}</span>
        @if (q.estimatedWaitingTime != undefined) {
        <span class="pvq-inline-wait">{{'field.label.estimated_wait' | translate | async}} : ~{{q.estimatedWaitingTime}} min</span>
        }
        }
      </div>
      }
      @if (showMessage) {
      <span class="view-queue-token-legend-container" style="color: white">{{'field.label.no_data_found' | translate | async}}</span>
      }
    </span>
    }
  </div>
</div>